import { Base } from "@studiometa/js-toolkit";
class Switcher extends Base {
  /**
   * Config.
   */
  static config = {
    name: "Switcher",
    refs: ["inputs[]"]
  };
  get value() {
    return this.$refs.inputs.find((input) => input.checked)?.value;
  }
  onInputsInput() {
    const { value } = this;
    if (typeof value === "undefined") {
      return;
    }
    this.switch(value);
    this.$emit("switch", { value });
  }
  switch(_value) {
    throw new Error("The `switch` method must be implemented.");
  }
}
export {
  Switcher as default
};
//# sourceMappingURL=Switcher.js.map
